'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';

const SubmitButton = ({
  submitting,
  disabled
}) => {
  if (submitting) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: "56px"
    });
  }

  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "password-login-button",
    id: "loginBtn",
    type: "submit",
    use: "primary",
    className: "m-bottom-4 login-submit",
    disabled: disabled,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.form.button"
    })
  });
};

SubmitButton.propTypes = {
  submitting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default SubmitButton;